import CrudCustom from '../../../libs/custom/CrudCustom';

let PegawaiGajiService = new CrudCustom('/pegawai-gajis');
export default PegawaiGajiService;
